import script from "./SurveyTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyTableRow.vue?vue&type=script&setup=true&lang=js"

import "./SurveyTableRow.vue?vue&type=style&index=0&id=38a8d798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a8d798"]])

export default __exports__